import { render, staticRenderFns } from "./cr_aba_formularios_editor.vue?vue&type=template&id=2f042387&"
import script from "./cr_aba_formularios_editor.vue?vue&type=script&lang=js&"
export * from "./cr_aba_formularios_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f042387')) {
      api.createRecord('2f042387', component.options)
    } else {
      api.reload('2f042387', component.options)
    }
    module.hot.accept("./cr_aba_formularios_editor.vue?vue&type=template&id=2f042387&", function () {
      api.rerender('2f042387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_aba_formularios_editor.vue"
export default component.exports